import { createAsyncThunk } from '@reduxjs/toolkit';
import apiManager from '../../../../api/api-manager';
import {
  getAPIRequestHeaders,
  getAPIRequestHeadersProspect,
} from '../../../../utils/api-utils';
import { SurveyRisposteFull } from '../../../../api/generated/dob';
import { QuestionnairesStatus } from '../../../../api/generated';
import { AsyncThunkConfig } from '../../../async-thunk-config';
import { HomeError } from '../home-types';
import mifidSurveyRepository from '../../../../repositories/onboarding-self/mifid-survey-repository';

export const getMifidTemplate = createAsyncThunk(
  'get-mifid-template',
  async (_, thunkApi) => {
    try {
      const response = await apiManager.dobSurveyApi.getMifidV2Template(
        'MIFID_PF',
        getAPIRequestHeaders(thunkApi)
      );
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue('GENERIC_ERROR');
    }
  }
);

export const getMifidAnswers = createAsyncThunk(
  'get-mifid-answers',
  async (req: { idCliente: string; idPratica: string }, thunkApi) => {
    try {
      const response = await apiManager.dobSurveyApi.getMifidV2Answers(
        req.idCliente,
        req.idPratica,
        false,
        'MIFID_PF',
        getAPIRequestHeaders(thunkApi)
      );
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue('GENERIC_ERROR');
    }
  }
);


export const getAmlAnswersForMifid = createAsyncThunk(
  'get-aml-answers.for-mifid',
  async (req: { idCliente: string; idPratica: string }, thunkApi) => {
    try {
      const response = await apiManager.mifidApiPrecompile.getMifidPrecompile(
        req.idCliente,
        req.idPratica,
        getAPIRequestHeaders(thunkApi)
      );
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue('GENERIC_ERROR');
    }
  }
);

export const saveMifidV2Full = createAsyncThunk(
  'save-mifid-full',
  async (req: SurveyRisposteFull, thunkApi) => {
    try {
      const response = await apiManager.dobSurveyApi.saveMifidV2Full(
        'MIFID_PF',
        req,
        getAPIRequestHeadersProspect(thunkApi)
      );
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue('GENERIC_ERROR');
    }
  }
);

export const updateStatusQuestionnaires = createAsyncThunk<
  void,
  QuestionnairesStatus,
  AsyncThunkConfig<HomeError>
>(
  'update-status-questionnaires',
  async (request: QuestionnairesStatus, thunkApi) => {
    try {
      const userState = thunkApi.getState().data.user;

      await apiManager.updateQuestionnairesStatus.updateQuestionnairesStatus(
        userState.username,
        request,
        getAPIRequestHeaders(thunkApi)
      );
      return null;
    } catch (error) {
      console.error(error);
      return thunkApi.rejectWithValue('GENERIC_ERROR');
    }
  }
);

export const registerMifid = createAsyncThunk<
  boolean,
  string | undefined,
  AsyncThunkConfig<HomeError>
>('register-mifid', async (codiceMifid: string | undefined, thunkApi) => {
  try {
    return await mifidSurveyRepository.registerMifid(codiceMifid, thunkApi);
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});
